module.exports = __webpack_public_path__ + "img/minus.ab6bb28e.svg";